import React from "react";
import { FaPlus } from "react-icons/fa6";
import { FaRegBuilding } from "react-icons/fa";
import Button from "../../../components/ui/Button";
import { strings } from "../../../strings/strings";

const EmptyState = ({ searchQuery, selectedStatus, onAddCompany }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-12 text-center">
      <FaRegBuilding className="w-16 h-16 mx-auto mb-4 text-gray-400 dark:text-gray-600" />
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{strings.NO_COMPANIES_FOUND}</h3>
      <p className="text-gray-600 dark:text-gray-400 mb-4">
        {searchQuery || selectedStatus !== "all"
          ? "Try adjusting your filters"
          : "Get started by adding your first company"}
      </p>
      {!searchQuery && selectedStatus === "all" && (
        <Button onClick={onAddCompany}>
          <FaPlus className="w-4 h-4 mr-2" />
          {strings.ADD_COMPANY}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
